
import {Inject} from "inversify-props"
import type { ItemDaPreVendaServiceAdapter } from './adapter'
import { ItemDaPreVendaImportacao } from "@/models/pre-venda/PreVenda"

export class ImportarItemDaPreVendaUseCase {
	@Inject('ItemDaPreVendaServiceAdapter')
	private itemDaPreVendaServiceAdapter!: ItemDaPreVendaServiceAdapter

	async importarItens(preVendaId: string, itens: ItemDaPreVendaImportacao[], tipoDePreVenda: string): Promise<any> {
		await this.itemDaPreVendaServiceAdapter.importarItens(preVendaId, itens, tipoDePreVenda)
	}
}